import { produce } from 'immer';
import type { CompByStaffItem, CompOrderLogItem, CompReasonItem, LabourEmployeeSalesItem, LabourEmployeeSalesSummary, LabourKpiComparisonResponse, LabourStaffPerformanceItem, LabourStaffPerformanceSummary, LabourTipsItem, LabourTipsSummary, LabourVoidsByEmployee, LabourVoidsReason, LabourVoidsResponse, LabourWorkingHoursItem, LabourWorkingHoursSummary, LabourWorkingHoursLogItem, LiveByChannelItem, LiveCategorySalesItem, LiveHourlySalesItem, LiveItemSalesV2Item, LiveOutstandingValueResponse, LivePaymentsItem, LiveRefundDetailsItem, LiveRefundSummaryItem, LiveStaffActiveClockingItem, LiveStaffActiveClockingV2Item, LiveStaffPerformanceItem, LiveStaffRefundsItem, LiveVoidByStaffItem, LiveVoidDetailsItem, LiveVoidKpisResponse, LiveVoidSummaryItem, OrderDetailResponse, OrderLogItem, RefundLogItem, RefundReasonsResponse, RefundByStaffResponse, RefundComponentSplitResponse, SalesByChannelBreakdownResponse, SnapshotComparisonResponse, SnapshotDetailsResponse, UnpaidOrderItem, HourlySalesResponse } from '../../../interface/clickHouseInterface';
import {
  FETCH_CLICKHOUSE_REQUEST,
  FETCH_CLICKHOUSE_SUCCESS,
  FETCH_CLICKHOUSE_FAILURE,
  FETCH_SNAPSHOT_DETAILS_REQUEST,
  FETCH_SNAPSHOT_DETAILS_SUCCESS,
  FETCH_SNAPSHOT_DETAILS_FAILURE,
  FETCH_LIVE_ITEM_SALES_V2_REQUEST,
  FETCH_LIVE_ITEM_SALES_V2_SUCCESS,
  FETCH_LIVE_ITEM_SALES_V2_FAILURE,
  FETCH_LIVE_BY_CHANNEL_REQUEST,
  FETCH_LIVE_BY_CHANNEL_SUCCESS,
  FETCH_LIVE_BY_CHANNEL_FAILURE,
  FETCH_THIRD_PARTY_BY_CHANNEL_REQUEST,
  FETCH_THIRD_PARTY_BY_CHANNEL_SUCCESS,
  FETCH_THIRD_PARTY_BY_CHANNEL_FAILURE,
  FETCH_LIVE_PAYMENTS_REQUEST,
  FETCH_LIVE_PAYMENTS_SUCCESS,
  FETCH_LIVE_PAYMENTS_FAILURE,
  FETCH_LIVE_REFUND_SUMMARY_REQUEST,
  FETCH_LIVE_REFUND_SUMMARY_SUCCESS,
  FETCH_LIVE_REFUND_SUMMARY_FAILURE,
  FETCH_LIVE_REFUND_DETAILS_REQUEST,
  FETCH_LIVE_REFUND_DETAILS_SUCCESS,
  FETCH_LIVE_REFUND_DETAILS_FAILURE,
  FETCH_REFUND_LOG_REQUEST,
  FETCH_REFUND_LOG_SUCCESS,
  FETCH_REFUND_LOG_FAILURE,
  FETCH_REFUND_REASONS_REQUEST,
  FETCH_REFUND_REASONS_SUCCESS,
  FETCH_REFUND_REASONS_FAILURE,
  FETCH_REFUND_BY_STAFF_REQUEST,
  FETCH_REFUND_BY_STAFF_SUCCESS,
  FETCH_REFUND_BY_STAFF_FAILURE,
  FETCH_REFUND_COMPONENT_SPLIT_REQUEST,
  FETCH_REFUND_COMPONENT_SPLIT_SUCCESS,
  FETCH_REFUND_COMPONENT_SPLIT_FAILURE,
  FETCH_LIVE_VOID_SUMMARY_REQUEST,
  FETCH_LIVE_VOID_SUMMARY_SUCCESS,
  FETCH_LIVE_VOID_SUMMARY_FAILURE,
  FETCH_VOID_BY_STAFF_REQUEST,
  FETCH_VOID_BY_STAFF_SUCCESS,
  FETCH_VOID_BY_STAFF_FAILURE,
  FETCH_VOID_KPIS_REQUEST,
  FETCH_VOID_KPIS_SUCCESS,
  FETCH_VOID_KPIS_FAILURE,
  FETCH_LIVE_VOID_DETAILS_REQUEST,
  FETCH_LIVE_VOID_DETAILS_SUCCESS,
  FETCH_LIVE_VOID_DETAILS_FAILURE,
  FETCH_LIVE_HOURLY_SALES_REQUEST,
  FETCH_LIVE_HOURLY_SALES_SUCCESS,
  FETCH_LIVE_HOURLY_SALES_FAILURE,
  FETCH_LIVE_STAFF_PERFORMANCE_REQUEST,
  FETCH_LIVE_STAFF_PERFORMANCE_SUCCESS,
  FETCH_LIVE_STAFF_PERFORMANCE_FAILURE,
  FETCH_LIVE_STAFF_ACTIVE_CLOCKING_REQUEST,
  FETCH_LIVE_STAFF_ACTIVE_CLOCKING_SUCCESS,
  FETCH_LIVE_STAFF_ACTIVE_CLOCKING_FAILURE,
  FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_REQUEST,
  FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_SUCCESS,
  FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_FAILURE,
  FETCH_ORDER_LOG_REQUEST,
  FETCH_ORDER_LOG_SUCCESS,
  FETCH_ORDER_LOG_FAILURE,
  FETCH_CANCELLED_ORDER_LOG_REQUEST,
  FETCH_CANCELLED_ORDER_LOG_SUCCESS,
  FETCH_CANCELLED_ORDER_LOG_FAILURE,
  EXPORT_ORDER_LOG_REQUEST,
  EXPORT_ORDER_LOG_SUCCESS,
  EXPORT_ORDER_LOG_FAILURE,
  EXPORT_ORDER_LOG_RESET,
  FETCH_ORDER_DETAIL_REQUEST,
  FETCH_ORDER_DETAIL_SUCCESS,
  FETCH_ORDER_DETAIL_FAILURE,
  CLEAR_ORDER_DETAIL,
  FETCH_LIVE_UNPAID_ORDERS_REQUEST,
  FETCH_LIVE_UNPAID_ORDERS_SUCCESS,
  FETCH_LIVE_UNPAID_ORDERS_FAILURE,
  FETCH_LIVE_UNPAID_LOG_REQUEST,
  FETCH_LIVE_UNPAID_LOG_SUCCESS,
  FETCH_LIVE_UNPAID_LOG_FAILURE,
  FETCH_LIVE_COMP_ORDER_LOG_REQUEST,
  FETCH_LIVE_COMP_ORDER_LOG_SUCCESS,
  FETCH_LIVE_COMP_ORDER_LOG_FAILURE,
  FETCH_LIVE_COMP_REASONS_REQUEST,
  FETCH_LIVE_COMP_REASONS_SUCCESS,
  FETCH_LIVE_COMP_REASONS_FAILURE,
  FETCH_LIVE_COMP_BY_STAFF_REQUEST,
  FETCH_LIVE_COMP_BY_STAFF_SUCCESS,
  FETCH_LIVE_COMP_BY_STAFF_FAILURE,
  FETCH_LIVE_CATEGORY_SALES_REQUEST,
  FETCH_LIVE_CATEGORY_SALES_SUCCESS,
  FETCH_LIVE_CATEGORY_SALES_FAILURE,
  FETCH_LIVE_STAFF_REFUNDS_REQUEST,
  FETCH_LIVE_STAFF_REFUNDS_SUCCESS,
  FETCH_LIVE_STAFF_REFUNDS_FAILURE,
  FETCH_SNAPSHOT_COMPARISON_REQUEST,
  FETCH_SNAPSHOT_COMPARISON_SUCCESS,
  FETCH_SNAPSHOT_COMPARISON_FAILURE,
  FETCH_CHANNEL_NAMES_REQUEST,
  FETCH_CHANNEL_NAMES_SUCCESS,
  FETCH_CHANNEL_NAMES_FAILURE,
  FETCH_LIVE_OUTSTANDING_VALUE_REQUEST,
  FETCH_LIVE_OUTSTANDING_VALUE_SUCCESS,
  FETCH_LIVE_OUTSTANDING_VALUE_FAILURE,
  FETCH_HOURLY_SALES_REQUEST,
  FETCH_HOURLY_SALES_SUCCESS,
  FETCH_HOURLY_SALES_FAILURE,
  FETCH_LABOUR_EMPLOYEE_SALES_REQUEST,
  FETCH_LABOUR_EMPLOYEE_SALES_SUCCESS,
  FETCH_LABOUR_EMPLOYEE_SALES_FAILURE,
  FETCH_LABOUR_TIPS_REQUEST,
  FETCH_LABOUR_TIPS_SUCCESS,
  FETCH_LABOUR_TIPS_FAILURE,
  FETCH_LABOUR_VOIDS_REQUEST,
  FETCH_LABOUR_VOIDS_SUCCESS,
  FETCH_LABOUR_VOIDS_FAILURE,
  FETCH_LABOUR_WORKING_HOURS_REQUEST,
  FETCH_LABOUR_WORKING_HOURS_SUCCESS,
  FETCH_LABOUR_WORKING_HOURS_FAILURE,
  FETCH_LABOUR_STAFF_PERFORMANCE_REQUEST,
  FETCH_LABOUR_STAFF_PERFORMANCE_SUCCESS,
  FETCH_LABOUR_STAFF_PERFORMANCE_FAILURE,
  FETCH_LABOUR_WORKING_HOURS_LOG_REQUEST,
  FETCH_LABOUR_WORKING_HOURS_LOG_SUCCESS,
  FETCH_LABOUR_WORKING_HOURS_LOG_FAILURE,
  FETCH_LABOUR_KPI_COMPARISON_REQUEST,
  FETCH_LABOUR_KPI_COMPARISON_SUCCESS,
  FETCH_LABOUR_KPI_COMPARISON_FAILURE,
  FETCH_LABOUR_EMPLOYEES_REQUEST,
  FETCH_LABOUR_EMPLOYEES_SUCCESS,
  FETCH_LABOUR_EMPLOYEES_FAILURE,
  FETCH_SALES_BY_CHANNEL_BREAKDOWN_REQUEST,
  FETCH_SALES_BY_CHANNEL_BREAKDOWN_SUCCESS,
  FETCH_SALES_BY_CHANNEL_BREAKDOWN_FAILURE,
  FETCH_LIVE_BY_SOURCE_REQUEST,
  FETCH_LIVE_BY_SOURCE_SUCCESS,
  FETCH_LIVE_BY_SOURCE_FAILURE,
} from './clickHouseConstants';

const initialState: {
  clickHouseLoading: boolean;
  clickHouseSuccess: any[];
  clickHouseFailure: boolean;
  snapshotDetailsLoading: boolean;
  snapshotDetailsSuccess: SnapshotDetailsResponse | null;
  snapshotDetailsFailure: boolean;
  liveItemSalesV2Loading: boolean;
  liveItemSalesV2Success: LiveItemSalesV2Item[];
  liveItemSalesV2Failure: boolean;
  liveItemSalesV2TotalElements: number;
  liveItemSalesV2TotalPages: number;
  liveByChannelLoading: boolean;
  liveByChannelSuccess: LiveByChannelItem[];
  liveByChannelFailure: boolean;
  // Unfiltered by-channel data for the Third-Party Marketplace card (never channel-filtered, SSE-16)
  thirdPartyByChannelLoading: boolean;
  thirdPartyByChannelSuccess: LiveByChannelItem[];
  thirdPartyByChannelFailure: boolean;
  livePaymentsLoading: boolean;
  livePaymentsSuccess: LivePaymentsItem[];
  livePaymentsFailure: boolean;
  liveRefundSummaryLoading: boolean;
  liveRefundSummarySuccess: LiveRefundSummaryItem[];
  liveRefundSummaryFailure: boolean;
  liveRefundDetailsLoading: boolean;
  liveRefundDetailsSuccess: LiveRefundDetailsItem[];
  liveRefundDetailsFailure: boolean;
  liveRefundDetailsTotalPages: number;
  liveRefundDetailsTotalElements: number;
  // REF-2 — the Refund Log's real data source.
  refundLogLoading: boolean;
  refundLogSuccess: RefundLogItem[];
  refundLogFailure: boolean;
  refundLogTotals: { totalRefunds: number; totalRefundedAmt: number; totalItemsAmt: number; totalFeesAmt: number } | null;
  // REF-6 — the Refund Reasons card's real data source.
  refundReasonsLoading: boolean;
  refundReasonsSuccess: RefundReasonsResponse | null;
  refundReasonsFailure: boolean;
  // REF-6 — the Refunds by Staff card's real data source.
  refundByStaffLoading: boolean;
  refundByStaffSuccess: RefundByStaffResponse | null;
  refundByStaffFailure: boolean;
  // REF-1 — the Component Split card's real data source.
  refundComponentSplitLoading: boolean;
  refundComponentSplitSuccess: RefundComponentSplitResponse | null;
  refundComponentSplitFailure: boolean;
  liveVoidSummaryLoading: boolean;
  liveVoidSummarySuccess: LiveVoidSummaryItem[];
  liveVoidSummaryFailure: boolean;
  voidByStaffLoading: boolean;
  voidByStaffSuccess: LiveVoidByStaffItem[];
  voidByStaffFailure: boolean;
  voidKpisLoading: boolean;
  voidKpisSuccess: LiveVoidKpisResponse | null;
  voidKpisFailure: boolean;
  liveVoidDetailsLoading: boolean;
  liveVoidDetailsSuccess: LiveVoidDetailsItem[];
  liveVoidDetailsFailure: boolean;
  liveVoidDetailsTotalPages: number;
  liveVoidDetailsTotalElements: number;
  liveHourlySalesLoading: boolean;
  liveHourlySalesSuccess: LiveHourlySalesItem[];
  liveHourlySalesFailure: boolean;
  hourlySalesLoading: boolean;
  hourlySalesData: HourlySalesResponse | null;
  hourlySalesFailure: boolean;
  liveStaffPerformanceLoading: boolean;
  liveStaffPerformanceSuccess: LiveStaffPerformanceItem[];
  liveStaffPerformanceFailure: boolean;
  liveStaffActiveClockingLoading: boolean;
  liveStaffActiveClockingSuccess: LiveStaffActiveClockingItem[];
  liveStaffActiveClockingFailure: boolean;
  // Staff Roster — /sales/live/v2/staff-active-clocking-v2
  liveStaffActiveClockingV2Loading: boolean;
  liveStaffActiveClockingV2Items: LiveStaffActiveClockingV2Item[];
  liveStaffActiveClockingV2TotalElements: number;
  liveStaffActiveClockingV2TotalPages: number;
  liveStaffActiveClockingV2StaffWorked: number;
  liveStaffActiveClockingV2ActiveCount: number;
  liveStaffActiveClockingV2BreakCount: number;
  liveStaffActiveClockingV2TotalWorkedHours: number;
  liveStaffActiveClockingV2TotalNetSales: number;
  liveStaffActiveClockingV2AvgSalesPerStaff: number;
  liveStaffActiveClockingV2Failure: boolean;
  // Order Log
  orderLogLoading: boolean;
  orderLogOrders: OrderLogItem[];
  orderLogTotalElements: number;
  orderLogTotalPages: number;
  orderLogFailure: boolean;
  // CANC-1 — cancelled orders (/order-log with type=cancel). Separate from orderLog* so the
  // Cancelled KPI/drill and the Paid Orders log can be on screen at once without clobbering.
  cancelledOrderLogLoading: boolean;
  cancelledOrderLogOrders: OrderLogItem[];
  cancelledOrderLogTotalElements: number;
  cancelledOrderLogTotalPages: number;
  cancelledOrderLogFailure: boolean;
  /** Segment counts for the period — returned by both the paid and cancel logs */
  orderLogPaidCount: number;
  orderLogCancelledCount: number;
  /** False when the outlet runs no table service (ORD-1.2) */
  orderLogDineInAvailable: boolean;
  // Export (reusable)
  exportOrderLogLoading: boolean;
  exportOrderLogSuccess: boolean;
  exportOrderLogError: string | null;
  // Order Detail
  orderDetailLoading: boolean;
  orderDetailData: OrderDetailResponse | null;
  orderDetailError: boolean;
  // Unpaid Orders summary (Today only — large-page fetch for KPI stats + By Server)
  liveUnpaidOrdersLoading: boolean;
  liveUnpaidOrders: UnpaidOrderItem[];
  liveUnpaidOrdersTotalElements: number;
  liveUnpaidOrdersFailure: boolean;
  // Unpaid Order Log (Today only — paginated table)
  liveUnpaidLogLoading: boolean;
  liveUnpaidLog: UnpaidOrderItem[];
  liveUnpaidLogTotalElements: number;
  liveUnpaidLogTotalPages: number;
  liveUnpaidLogFailure: boolean;
  /** The unpaid log's own table-service answer — see orderLogDineInAvailable. */
  liveUnpaidLogDineInAvailable: boolean;
  // Comp Order Log (Today only)
  liveCompOrderLogLoading: boolean;
  liveCompOrderLog: CompOrderLogItem[];
  liveCompOrderLogTotalElements: number;
  liveCompOrderLogTotalPages: number;
  liveCompOrderLogFailure: boolean;
  // Comp Reasons (Today only)
  liveCompReasonsLoading: boolean;
  liveCompReasons: CompReasonItem[];
  liveCompReasonsFailure: boolean;
  // Comp by Staff (Today only)
  liveCompByStaffLoading: boolean;
  liveCompByStaff: CompByStaffItem[];
  liveCompByStaffFailure: boolean;
  // Sales by Category (page/size paginated)
  liveCategorySalesLoading: boolean;
  liveCategorySalesSuccess: LiveCategorySalesItem[];
  liveCategorySalesFailure: boolean;
  liveCategorySalesPage: number;
  liveCategorySalesSize: number;
  liveCategorySalesTotalElements: number;
  liveCategorySalesTotalPages: number;
  // Staff Refunds (Today only)
  liveStaffRefundsLoading: boolean;
  liveStaffRefundsSuccess: LiveStaffRefundsItem[];
  liveStaffRefundsFailure: boolean;
  // Snapshot Comparison — percentage deltas vs yesterday (Today only)
  snapshotComparisonLoading: boolean;
  snapshotComparisonSuccess: SnapshotComparisonResponse | null;
  snapshotComparisonFailure: boolean;
  // Channel Names — Order Log dropdown
  channelNames: string[];
  channelNamesLoading: boolean;
  channelNamesError: boolean;
  // Outstanding Value (Today only)
  liveOutstandingValueLoading: boolean;
  liveOutstandingValue: LiveOutstandingValueResponse | null;
  liveOutstandingValueFailure: boolean;
  // Labour Staff Performance — GET /sales/live/v2/labour-staff-performance
  labourEmployeeSalesLoading: boolean;
  labourEmployeeSalesItems: LabourEmployeeSalesItem[];
  labourEmployeeSalesSummary: LabourEmployeeSalesSummary | null;
  labourEmployeeSalesFailure: boolean;

  labourTipsLoading: boolean;
  labourTipsItems: LabourTipsItem[];
  labourTipsSummary: LabourTipsSummary | null;
  labourTipsFailure: boolean;

  labourVoidsLoading: boolean;
  labourVoidsData: LabourVoidsResponse | null;
  labourVoidsFailure: boolean;

  labourWorkingHoursLoading: boolean;
  labourWorkingHoursItems: LabourWorkingHoursItem[];
  labourWorkingHoursTotalElements: number;
  labourWorkingHoursSummary: LabourWorkingHoursSummary | null;
  labourWorkingHoursFailure: boolean;

  labourStaffPerformanceLoading: boolean;
  labourStaffPerformanceItems: LabourStaffPerformanceItem[];
  labourStaffPerformanceTotalElements: number;
  labourStaffPerformanceTotalPages: number;
  labourStaffPerformanceSummary: LabourStaffPerformanceSummary | null;
  labourStaffPerformanceFailure: boolean;
  // Labour Working Hours Log — GET /sales/live/v2/labour-working-hours-log
  labourWorkingHoursLogLoading: boolean;
  labourWorkingHoursLogItems: LabourWorkingHoursLogItem[];
  labourWorkingHoursLogTotalElements: number;
  labourWorkingHoursLogTotalPages: number;
  labourWorkingHoursLogFailure: boolean;

  labourKpiComparisonLoading: boolean;
  labourKpiComparison: LabourKpiComparisonResponse | null;
  labourKpiComparisonFailure: boolean;

  labourEmployeesLoading: boolean;
  labourEmployees: { staffId: string; staffName: string }[];
  labourEmployeesFailure: boolean;
  // Sales by Channel — Financial Breakdown (ZAR-1555)
  salesByChannelBreakdownLoading: boolean;
  salesByChannelBreakdown: SalesByChannelBreakdownResponse | null;
  salesByChannelBreakdownFailure: boolean;
  // Sales by Channel / Source card (ZAR-2371) — by-channel?type=source rows
  liveBySourceLoading: boolean;
  liveBySourceSuccess: LiveByChannelItem[];
  liveBySourceFailure: boolean;
} = {
  clickHouseLoading: false,
  clickHouseSuccess: [],
  clickHouseFailure: false,

  snapshotDetailsLoading: false,
  snapshotDetailsSuccess: null,
  snapshotDetailsFailure: false,

  liveItemSalesV2Loading: false,
  liveItemSalesV2Success: [],
  liveItemSalesV2Failure: false,
  liveItemSalesV2TotalElements: 0,
  liveItemSalesV2TotalPages: 1,

  liveByChannelLoading: false,
  liveByChannelSuccess: [],
  liveByChannelFailure: false,
  thirdPartyByChannelLoading: false,
  thirdPartyByChannelSuccess: [],
  thirdPartyByChannelFailure: false,

  livePaymentsLoading: false,
  livePaymentsSuccess: [],
  livePaymentsFailure: false,

  liveRefundSummaryLoading: false,
  liveRefundSummarySuccess: [],
  liveRefundSummaryFailure: false,

  liveRefundDetailsLoading: false,
  liveRefundDetailsSuccess: [],
  liveRefundDetailsFailure: false,
  liveRefundDetailsTotalPages: 1,
  liveRefundDetailsTotalElements: 0,
  refundLogLoading: false,
  refundLogSuccess: [],
  refundLogFailure: false,
  refundLogTotals: null,
  refundReasonsLoading: false,
  refundReasonsSuccess: null,
  refundReasonsFailure: false,
  refundByStaffLoading: false,
  refundByStaffSuccess: null,
  refundByStaffFailure: false,
  refundComponentSplitLoading: false,
  refundComponentSplitSuccess: null,
  refundComponentSplitFailure: false,

  liveVoidSummaryLoading: false,
  liveVoidSummarySuccess: [],
  liveVoidSummaryFailure: false,

  voidByStaffLoading: false,
  voidByStaffSuccess: [],
  voidByStaffFailure: false,

  voidKpisLoading: false,
  voidKpisSuccess: null,
  voidKpisFailure: false,

  liveVoidDetailsLoading: false,
  liveVoidDetailsSuccess: [],
  liveVoidDetailsFailure: false,
  liveVoidDetailsTotalPages: 1,
  liveVoidDetailsTotalElements: 0,

  liveHourlySalesLoading: false,
  liveHourlySalesSuccess: [],
  liveHourlySalesFailure: false,

  hourlySalesLoading: false,
  hourlySalesData: null,
  hourlySalesFailure: false,

  liveStaffPerformanceLoading: false,
  liveStaffPerformanceSuccess: [],
  liveStaffPerformanceFailure: false,

  liveStaffActiveClockingLoading: false,
  liveStaffActiveClockingSuccess: [],
  liveStaffActiveClockingFailure: false,

  liveStaffActiveClockingV2Loading: false,
  liveStaffActiveClockingV2Items: [],
  liveStaffActiveClockingV2TotalElements: 0,
  liveStaffActiveClockingV2TotalPages: 1,
  liveStaffActiveClockingV2StaffWorked: 0,
  liveStaffActiveClockingV2ActiveCount: 0,
  liveStaffActiveClockingV2BreakCount: 0,
  liveStaffActiveClockingV2TotalWorkedHours: 0,
  liveStaffActiveClockingV2TotalNetSales: 0,
  liveStaffActiveClockingV2AvgSalesPerStaff: 0,
  liveStaffActiveClockingV2Failure: false,

  orderLogLoading: false,
  orderLogOrders: [],
  orderLogTotalElements: 0,
  orderLogTotalPages: 1,
  orderLogFailure: false,
  cancelledOrderLogLoading: false,
  cancelledOrderLogOrders: [],
  cancelledOrderLogTotalElements: 0,
  cancelledOrderLogTotalPages: 1,
  cancelledOrderLogFailure: false,
  orderLogPaidCount: 0,
  orderLogCancelledCount: 0,
  orderLogDineInAvailable: true,

  exportOrderLogLoading: false,
  exportOrderLogSuccess: false,
  exportOrderLogError: null,

  orderDetailLoading: false,
  orderDetailData: null,
  orderDetailError: false,

  liveUnpaidOrdersLoading: false,
  liveUnpaidOrders: [],
  liveUnpaidOrdersTotalElements: 0,
  liveUnpaidOrdersFailure: false,

  liveUnpaidLogLoading: false,
  liveUnpaidLog: [],
  liveUnpaidLogTotalElements: 0,
  liveUnpaidLogTotalPages: 1,
  liveUnpaidLogFailure: false,
  liveUnpaidLogDineInAvailable: true,

  liveCompOrderLogLoading: false,
  liveCompOrderLog: [],
  liveCompOrderLogTotalElements: 0,
  liveCompOrderLogTotalPages: 1,
  liveCompOrderLogFailure: false,

  liveCompReasonsLoading: false,
  liveCompReasons: [],
  liveCompReasonsFailure: false,

  liveCompByStaffLoading: false,
  liveCompByStaff: [],
  liveCompByStaffFailure: false,

  liveCategorySalesLoading: false,
  liveCategorySalesSuccess: [],
  liveCategorySalesFailure: false,
  liveCategorySalesPage: 1,
  liveCategorySalesSize: 5,
  liveCategorySalesTotalElements: 0,
  liveCategorySalesTotalPages: 1,

  liveStaffRefundsLoading: false,
  liveStaffRefundsSuccess: [],
  liveStaffRefundsFailure: false,

  snapshotComparisonLoading: false,
  snapshotComparisonSuccess: null,
  snapshotComparisonFailure: false,

  channelNames: [],
  channelNamesLoading: false,
  channelNamesError: false,

  liveOutstandingValueLoading: false,
  liveOutstandingValue: null,
  liveOutstandingValueFailure: false,

  labourEmployeeSalesLoading: false,
  labourEmployeeSalesItems: [],
  labourEmployeeSalesSummary: null,
  labourEmployeeSalesFailure: false,

  labourTipsLoading: false,
  labourTipsItems: [],
  labourTipsSummary: null,
  labourTipsFailure: false,

  labourVoidsLoading: false,
  labourVoidsData: null,
  labourVoidsFailure: false,

  labourWorkingHoursLoading: false,
  labourWorkingHoursItems: [],
  labourWorkingHoursTotalElements: 0,
  labourWorkingHoursSummary: null,
  labourWorkingHoursFailure: false,

  labourStaffPerformanceLoading: false,
  labourStaffPerformanceItems: [],
  labourStaffPerformanceTotalElements: 0,
  labourStaffPerformanceTotalPages: 1,
  labourStaffPerformanceSummary: null,
  labourStaffPerformanceFailure: false,

  labourWorkingHoursLogLoading: false,
  labourWorkingHoursLogItems: [],
  labourWorkingHoursLogTotalElements: 0,
  labourWorkingHoursLogTotalPages: 1,
  labourWorkingHoursLogFailure: false,

  labourKpiComparisonLoading: false,
  labourKpiComparison: null,
  labourKpiComparisonFailure: false,

  labourEmployeesLoading: false,
  labourEmployees: [],
  labourEmployeesFailure: false,

  salesByChannelBreakdownLoading: false,
  salesByChannelBreakdown: null,
  salesByChannelBreakdownFailure: false,
  liveBySourceLoading: false,
  liveBySourceSuccess: [],
  liveBySourceFailure: false,
};

export default function clickHouseReducer(state = initialState, action: any) {
  return produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CLICKHOUSE_REQUEST:
        draft.clickHouseLoading = true;
        draft.clickHouseSuccess = [];
        draft.clickHouseFailure = false;
        break;
      case FETCH_CLICKHOUSE_SUCCESS:
        draft.clickHouseLoading = false;
        draft.clickHouseSuccess = action.payload;
        draft.clickHouseFailure = false;
        break;
      case FETCH_CLICKHOUSE_FAILURE:
        draft.clickHouseLoading = false;
        draft.clickHouseSuccess = [];
        draft.clickHouseFailure = true;
        break;

      case FETCH_SNAPSHOT_DETAILS_REQUEST:
        draft.snapshotDetailsLoading = true;
        draft.snapshotDetailsSuccess = null;
        draft.snapshotDetailsFailure = false;
        break;
      case FETCH_SNAPSHOT_DETAILS_SUCCESS:
        draft.snapshotDetailsLoading = false;
        draft.snapshotDetailsSuccess = action.payload;
        draft.snapshotDetailsFailure = false;
        break;
      case FETCH_SNAPSHOT_DETAILS_FAILURE:
        draft.snapshotDetailsLoading = false;
        draft.snapshotDetailsSuccess = null;
        draft.snapshotDetailsFailure = true;
        break;

      case FETCH_LIVE_ITEM_SALES_V2_REQUEST:
        draft.liveItemSalesV2Loading = true;
        draft.liveItemSalesV2Success = [];
        draft.liveItemSalesV2Failure = false;
        // Keep TotalElements/TotalPages from the previous successful response so
        // export always has the real count even while a new page is loading.
        break;
      case FETCH_LIVE_ITEM_SALES_V2_SUCCESS:
        draft.liveItemSalesV2Loading = false;
        draft.liveItemSalesV2Success = action.payload.content ?? [];
        draft.liveItemSalesV2TotalElements = Number(action.payload.totalElements) || 0;
        draft.liveItemSalesV2TotalPages = Number(action.payload.totalPages) || 1;
        draft.liveItemSalesV2Failure = false;
        break;
      case FETCH_LIVE_ITEM_SALES_V2_FAILURE:
        draft.liveItemSalesV2Loading = false;
        draft.liveItemSalesV2Success = [];
        draft.liveItemSalesV2TotalElements = 0;
        draft.liveItemSalesV2TotalPages = 1;
        draft.liveItemSalesV2Failure = true;
        break;

      case FETCH_LIVE_BY_CHANNEL_REQUEST:
        draft.liveByChannelLoading = true;
        draft.liveByChannelSuccess = [];
        draft.liveByChannelFailure = false;
        break;
      case FETCH_LIVE_BY_CHANNEL_SUCCESS:
        draft.liveByChannelLoading = false;
        draft.liveByChannelSuccess = action.payload;
        draft.liveByChannelFailure = false;
        break;
      case FETCH_LIVE_BY_CHANNEL_FAILURE:
        draft.liveByChannelLoading = false;
        draft.liveByChannelSuccess = [];
        draft.liveByChannelFailure = true;
        break;
      case FETCH_THIRD_PARTY_BY_CHANNEL_REQUEST:
        draft.thirdPartyByChannelLoading = true;
        draft.thirdPartyByChannelSuccess = [];
        draft.thirdPartyByChannelFailure = false;
        break;
      case FETCH_THIRD_PARTY_BY_CHANNEL_SUCCESS:
        draft.thirdPartyByChannelLoading = false;
        draft.thirdPartyByChannelSuccess = action.payload;
        draft.thirdPartyByChannelFailure = false;
        break;
      case FETCH_THIRD_PARTY_BY_CHANNEL_FAILURE:
        draft.thirdPartyByChannelLoading = false;
        draft.thirdPartyByChannelSuccess = [];
        draft.thirdPartyByChannelFailure = true;
        break;

      case FETCH_LIVE_PAYMENTS_REQUEST:
        draft.livePaymentsLoading = true;
        draft.livePaymentsSuccess = [];
        draft.livePaymentsFailure = false;
        break;
      case FETCH_LIVE_PAYMENTS_SUCCESS:
        draft.livePaymentsLoading = false;
        draft.livePaymentsSuccess = action.payload;
        draft.livePaymentsFailure = false;
        break;
      case FETCH_LIVE_PAYMENTS_FAILURE:
        draft.livePaymentsLoading = false;
        draft.livePaymentsSuccess = [];
        draft.livePaymentsFailure = true;
        break;

      case FETCH_LIVE_REFUND_SUMMARY_REQUEST:
        draft.liveRefundSummaryLoading = true;
        draft.liveRefundSummarySuccess = [];
        draft.liveRefundSummaryFailure = false;
        break;
      case FETCH_LIVE_REFUND_SUMMARY_SUCCESS:
        draft.liveRefundSummaryLoading = false;
        draft.liveRefundSummarySuccess = action.payload;
        draft.liveRefundSummaryFailure = false;
        break;
      case FETCH_LIVE_REFUND_SUMMARY_FAILURE:
        draft.liveRefundSummaryLoading = false;
        draft.liveRefundSummarySuccess = [];
        draft.liveRefundSummaryFailure = true;
        break;

      case FETCH_LIVE_REFUND_DETAILS_REQUEST:
        draft.liveRefundDetailsLoading = true;
        draft.liveRefundDetailsSuccess = [];
        draft.liveRefundDetailsFailure = false;
        break;
      case FETCH_LIVE_REFUND_DETAILS_SUCCESS:
        draft.liveRefundDetailsLoading = false;
        draft.liveRefundDetailsSuccess = action.payload.content ?? [];
        draft.liveRefundDetailsTotalPages = Number(action.payload.totalPages) || 1;
        draft.liveRefundDetailsTotalElements = Number(action.payload.totalElements) || draft.liveRefundDetailsSuccess.length;
        draft.liveRefundDetailsFailure = false;
        break;
      case FETCH_LIVE_REFUND_DETAILS_FAILURE:
        draft.liveRefundDetailsLoading = false;
        draft.liveRefundDetailsSuccess = [];
        draft.liveRefundDetailsTotalPages = 1;
        draft.liveRefundDetailsTotalElements = 0;
        draft.liveRefundDetailsFailure = true;
        break;

      case FETCH_REFUND_LOG_REQUEST:
        draft.refundLogLoading = true;
        draft.refundLogSuccess = [];
        draft.refundLogTotals = null;
        draft.refundLogFailure = false;
        break;
      case FETCH_REFUND_LOG_SUCCESS:
        draft.refundLogLoading = false;
        draft.refundLogSuccess = action.payload.content ?? [];
        draft.refundLogTotals = {
          totalRefunds: Number(action.payload.totalRefunds) || 0,
          totalRefundedAmt: Number(action.payload.totalRefundedAmt) || 0,
          totalItemsAmt: Number(action.payload.totalItemsAmt) || 0,
          totalFeesAmt: Number(action.payload.totalFeesAmt) || 0,
        };
        draft.refundLogFailure = false;
        break;
      case FETCH_REFUND_LOG_FAILURE:
        draft.refundLogLoading = false;
        draft.refundLogSuccess = [];
        draft.refundLogTotals = null;
        draft.refundLogFailure = true;
        break;

      case FETCH_REFUND_REASONS_REQUEST:
        draft.refundReasonsLoading = true;
        // A page/size change keeps the current rows up while the next page loads; a new
        // period / source / outlet clears them so stale rows never label the new context.
        if (!action.payload.keepPrevious) draft.refundReasonsSuccess = null;
        draft.refundReasonsFailure = false;
        break;
      case FETCH_REFUND_REASONS_SUCCESS:
        draft.refundReasonsLoading = false;
        draft.refundReasonsSuccess = action.payload;
        draft.refundReasonsFailure = false;
        break;
      case FETCH_REFUND_REASONS_FAILURE:
        draft.refundReasonsLoading = false;
        draft.refundReasonsSuccess = null;
        draft.refundReasonsFailure = true;
        break;

      case FETCH_REFUND_BY_STAFF_REQUEST:
        draft.refundByStaffLoading = true;
        if (!action.payload.keepPrevious) draft.refundByStaffSuccess = null;
        draft.refundByStaffFailure = false;
        break;
      case FETCH_REFUND_BY_STAFF_SUCCESS:
        draft.refundByStaffLoading = false;
        draft.refundByStaffSuccess = action.payload;
        draft.refundByStaffFailure = false;
        break;
      case FETCH_REFUND_BY_STAFF_FAILURE:
        draft.refundByStaffLoading = false;
        draft.refundByStaffSuccess = null;
        draft.refundByStaffFailure = true;
        break;

      case FETCH_REFUND_COMPONENT_SPLIT_REQUEST:
        draft.refundComponentSplitLoading = true;
        draft.refundComponentSplitSuccess = null;
        draft.refundComponentSplitFailure = false;
        break;
      case FETCH_REFUND_COMPONENT_SPLIT_SUCCESS:
        draft.refundComponentSplitLoading = false;
        draft.refundComponentSplitSuccess = action.payload;
        draft.refundComponentSplitFailure = false;
        break;
      case FETCH_REFUND_COMPONENT_SPLIT_FAILURE:
        draft.refundComponentSplitLoading = false;
        draft.refundComponentSplitSuccess = null;
        draft.refundComponentSplitFailure = true;
        break;

      case FETCH_LIVE_VOID_SUMMARY_REQUEST:
        draft.liveVoidSummaryLoading = true;
        draft.liveVoidSummarySuccess = [];
        draft.liveVoidSummaryFailure = false;
        break;
      case FETCH_LIVE_VOID_SUMMARY_SUCCESS:
        draft.liveVoidSummaryLoading = false;
        draft.liveVoidSummarySuccess = action.payload;
        draft.liveVoidSummaryFailure = false;
        break;
      case FETCH_LIVE_VOID_SUMMARY_FAILURE:
        draft.liveVoidSummaryLoading = false;
        draft.liveVoidSummarySuccess = [];
        draft.liveVoidSummaryFailure = true;
        break;

      case FETCH_VOID_BY_STAFF_REQUEST:
        draft.voidByStaffLoading = true;
        draft.voidByStaffSuccess = [];
        draft.voidByStaffFailure = false;
        break;
      case FETCH_VOID_BY_STAFF_SUCCESS:
        draft.voidByStaffLoading = false;
        draft.voidByStaffSuccess = action.payload;
        draft.voidByStaffFailure = false;
        break;
      case FETCH_VOID_BY_STAFF_FAILURE:
        draft.voidByStaffLoading = false;
        draft.voidByStaffSuccess = [];
        draft.voidByStaffFailure = true;
        break;

      case FETCH_VOID_KPIS_REQUEST:
        draft.voidKpisLoading = true;
        draft.voidKpisSuccess = null;
        draft.voidKpisFailure = false;
        break;
      case FETCH_VOID_KPIS_SUCCESS:
        draft.voidKpisLoading = false;
        draft.voidKpisSuccess = action.payload;
        draft.voidKpisFailure = false;
        break;
      case FETCH_VOID_KPIS_FAILURE:
        draft.voidKpisLoading = false;
        draft.voidKpisSuccess = null;
        draft.voidKpisFailure = true;
        break;

      case FETCH_LIVE_VOID_DETAILS_REQUEST:
        draft.liveVoidDetailsLoading = true;
        draft.liveVoidDetailsSuccess = [];
        draft.liveVoidDetailsFailure = false;
        break;
      case FETCH_LIVE_VOID_DETAILS_SUCCESS:
        draft.liveVoidDetailsLoading = false;
        draft.liveVoidDetailsSuccess = action.payload.content ?? [];
        draft.liveVoidDetailsTotalPages = Number(action.payload.totalPages) || 1;
        draft.liveVoidDetailsTotalElements = Number(action.payload.totalElements) || 0;
        draft.liveVoidDetailsFailure = false;
        break;
      case FETCH_LIVE_VOID_DETAILS_FAILURE:
        draft.liveVoidDetailsLoading = false;
        draft.liveVoidDetailsSuccess = [];
        draft.liveVoidDetailsTotalPages = 1;
        draft.liveVoidDetailsTotalElements = 0;
        draft.liveVoidDetailsFailure = true;
        break;

      case FETCH_LIVE_HOURLY_SALES_REQUEST:
        draft.liveHourlySalesLoading = true;
        draft.liveHourlySalesSuccess = [];
        draft.liveHourlySalesFailure = false;
        break;
      case FETCH_LIVE_HOURLY_SALES_SUCCESS:
        draft.liveHourlySalesLoading = false;
        draft.liveHourlySalesSuccess = action.payload;
        draft.liveHourlySalesFailure = false;
        break;
      case FETCH_LIVE_HOURLY_SALES_FAILURE:
        draft.liveHourlySalesLoading = false;
        draft.liveHourlySalesSuccess = [];
        draft.liveHourlySalesFailure = true;
        break;

      case FETCH_HOURLY_SALES_REQUEST:
        draft.hourlySalesLoading = true;
        draft.hourlySalesData = null;
        draft.hourlySalesFailure = false;
        break;
      case FETCH_HOURLY_SALES_SUCCESS:
        draft.hourlySalesLoading = false;
        draft.hourlySalesData = action.payload;
        draft.hourlySalesFailure = false;
        break;
      case FETCH_HOURLY_SALES_FAILURE:
        draft.hourlySalesLoading = false;
        draft.hourlySalesData = null;
        draft.hourlySalesFailure = true;
        break;

      case FETCH_LIVE_STAFF_PERFORMANCE_REQUEST:
        draft.liveStaffPerformanceLoading = true;
        draft.liveStaffPerformanceSuccess = [];
        draft.liveStaffPerformanceFailure = false;
        break;
      case FETCH_LIVE_STAFF_PERFORMANCE_SUCCESS:
        draft.liveStaffPerformanceLoading = false;
        draft.liveStaffPerformanceSuccess = action.payload;
        draft.liveStaffPerformanceFailure = false;
        break;
      case FETCH_LIVE_STAFF_PERFORMANCE_FAILURE:
        draft.liveStaffPerformanceLoading = false;
        draft.liveStaffPerformanceSuccess = [];
        draft.liveStaffPerformanceFailure = true;
        break;

      case FETCH_LIVE_STAFF_ACTIVE_CLOCKING_REQUEST:
        draft.liveStaffActiveClockingLoading = true;
        draft.liveStaffActiveClockingSuccess = [];
        draft.liveStaffActiveClockingFailure = false;
        break;
      case FETCH_LIVE_STAFF_ACTIVE_CLOCKING_SUCCESS:
        draft.liveStaffActiveClockingLoading = false;
        draft.liveStaffActiveClockingSuccess = action.payload;
        draft.liveStaffActiveClockingFailure = false;
        break;
      case FETCH_LIVE_STAFF_ACTIVE_CLOCKING_FAILURE:
        draft.liveStaffActiveClockingLoading = false;
        draft.liveStaffActiveClockingSuccess = [];
        draft.liveStaffActiveClockingFailure = true;
        break;

      case FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_REQUEST:
        draft.liveStaffActiveClockingV2Loading = true;
        draft.liveStaffActiveClockingV2Items = [];
        draft.liveStaffActiveClockingV2Failure = false;
        break;
      case FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_SUCCESS:
        draft.liveStaffActiveClockingV2Loading = false;
        draft.liveStaffActiveClockingV2Items = action.payload.content ?? [];
        draft.liveStaffActiveClockingV2TotalElements = Number(action.payload.totalElements) || 0;
        draft.liveStaffActiveClockingV2TotalPages = Number(action.payload.totalPages) || 1;
        draft.liveStaffActiveClockingV2StaffWorked = Number(action.payload.staffWorked) || 0;
        draft.liveStaffActiveClockingV2ActiveCount = Number(action.payload.activeCount) || 0;
        draft.liveStaffActiveClockingV2BreakCount = Number(action.payload.breakCount) || 0;
        draft.liveStaffActiveClockingV2TotalWorkedHours = Number(action.payload.totalWorkedHours) || 0;
        draft.liveStaffActiveClockingV2TotalNetSales = Number(action.payload.totalNetSales) || 0;
        draft.liveStaffActiveClockingV2AvgSalesPerStaff = Number(action.payload.avgSalesPerStaff) || 0;
        draft.liveStaffActiveClockingV2Failure = false;
        break;
      case FETCH_LIVE_STAFF_ACTIVE_CLOCKING_V2_FAILURE:
        draft.liveStaffActiveClockingV2Loading = false;
        draft.liveStaffActiveClockingV2Items = [];
        draft.liveStaffActiveClockingV2TotalElements = 0;
        draft.liveStaffActiveClockingV2TotalPages = 1;
        draft.liveStaffActiveClockingV2Failure = true;
        break;

      case FETCH_ORDER_LOG_REQUEST:
        draft.orderLogLoading = true;
        draft.orderLogOrders = [];
        draft.orderLogFailure = false;
        break;
      case FETCH_ORDER_LOG_SUCCESS:
        draft.orderLogLoading = false;
        draft.orderLogOrders = action.payload.orders ?? [];
        draft.orderLogTotalElements = Number(action.payload.totalElements) || 0;
        draft.orderLogTotalPages = Number(action.payload.totalPages) || 1;
        draft.orderLogPaidCount = Number(action.payload.paidCount) || 0;
        draft.orderLogCancelledCount = Number(action.payload.cancelledCount) || 0;
        // Absent means "not told" — keep the column rather than hiding it.
        draft.orderLogDineInAvailable = action.payload.isDineInAvailable !== false;
        draft.orderLogFailure = false;
        break;
      case FETCH_CANCELLED_ORDER_LOG_REQUEST:
        draft.cancelledOrderLogLoading = true;
        draft.cancelledOrderLogFailure = false;
        break;
      case FETCH_CANCELLED_ORDER_LOG_SUCCESS:
        draft.cancelledOrderLogLoading = false;
        draft.cancelledOrderLogOrders = action.payload.orders ?? [];
        draft.cancelledOrderLogTotalElements = Number(action.payload.totalElements) || 0;
        draft.cancelledOrderLogTotalPages = Number(action.payload.totalPages) || 1;
        draft.cancelledOrderLogFailure = false;
        break;
      case FETCH_CANCELLED_ORDER_LOG_FAILURE:
        draft.cancelledOrderLogLoading = false;
        draft.cancelledOrderLogOrders = [];
        draft.cancelledOrderLogTotalElements = 0;
        draft.cancelledOrderLogTotalPages = 1;
        draft.cancelledOrderLogFailure = true;
        break;
      case FETCH_ORDER_LOG_FAILURE:
        draft.orderLogLoading = false;
        draft.orderLogOrders = [];
        draft.orderLogTotalElements = 0;
        draft.orderLogTotalPages = 1;
        draft.orderLogFailure = true;
        break;

      case EXPORT_ORDER_LOG_REQUEST:
        draft.exportOrderLogLoading = true;
        draft.exportOrderLogSuccess = false;
        draft.exportOrderLogError = null;
        break;
      case EXPORT_ORDER_LOG_SUCCESS:
        draft.exportOrderLogLoading = false;
        draft.exportOrderLogSuccess = true;
        draft.exportOrderLogError = null;
        break;
      case EXPORT_ORDER_LOG_FAILURE:
        draft.exportOrderLogLoading = false;
        draft.exportOrderLogSuccess = false;
        draft.exportOrderLogError = action.payload.error;
        break;
      case EXPORT_ORDER_LOG_RESET:
        draft.exportOrderLogLoading = false;
        draft.exportOrderLogSuccess = false;
        draft.exportOrderLogError = null;
        break;

      case FETCH_ORDER_DETAIL_REQUEST:
        draft.orderDetailLoading = true;
        draft.orderDetailData = null;
        draft.orderDetailError = false;
        break;
      case FETCH_ORDER_DETAIL_SUCCESS:
        draft.orderDetailLoading = false;
        draft.orderDetailData = action.payload;
        draft.orderDetailError = false;
        break;
      case FETCH_ORDER_DETAIL_FAILURE:
        draft.orderDetailLoading = false;
        draft.orderDetailData = null;
        draft.orderDetailError = true;
        break;
      case CLEAR_ORDER_DETAIL:
        draft.orderDetailLoading = false;
        draft.orderDetailData = null;
        draft.orderDetailError = false;
        break;

      case FETCH_LIVE_UNPAID_ORDERS_REQUEST:
        draft.liveUnpaidOrdersLoading = true;
        draft.liveUnpaidOrders = [];
        draft.liveUnpaidOrdersTotalElements = 0;
        draft.liveUnpaidOrdersFailure = false;
        break;
      case FETCH_LIVE_UNPAID_ORDERS_SUCCESS:
        draft.liveUnpaidOrdersLoading = false;
        draft.liveUnpaidOrders = action.payload.orders ?? [];
        draft.liveUnpaidOrdersTotalElements = Number(action.payload.totalElements) || 0;
        // Same endpoint as the unpaid log, so it answers table service too — set
        // here as well, and the drill opens with the right columns on first paint.
        draft.liveUnpaidLogDineInAvailable = action.payload.isDineInAvailable !== false;
        draft.liveUnpaidOrdersFailure = false;
        break;
      case FETCH_LIVE_UNPAID_ORDERS_FAILURE:
        draft.liveUnpaidOrdersLoading = false;
        draft.liveUnpaidOrders = [];
        draft.liveUnpaidOrdersTotalElements = 0;
        draft.liveUnpaidOrdersFailure = true;
        break;

      case FETCH_LIVE_UNPAID_LOG_REQUEST:
        draft.liveUnpaidLogLoading = true;
        draft.liveUnpaidLog = [];
        draft.liveUnpaidLogFailure = false;
        break;
      case FETCH_LIVE_UNPAID_LOG_SUCCESS:
        draft.liveUnpaidLogLoading = false;
        draft.liveUnpaidLog = action.payload.orders ?? [];
        draft.liveUnpaidLogTotalElements = Number(action.payload.totalElements) || 0;
        draft.liveUnpaidLogTotalPages = Number(action.payload.totalPages) || 1;
        // Absent means "not told" — keep the column rather than hiding it.
        draft.liveUnpaidLogDineInAvailable = action.payload.isDineInAvailable !== false;
        draft.liveUnpaidLogFailure = false;
        break;
      case FETCH_LIVE_UNPAID_LOG_FAILURE:
        draft.liveUnpaidLogLoading = false;
        draft.liveUnpaidLog = [];
        draft.liveUnpaidLogTotalElements = 0;
        draft.liveUnpaidLogTotalPages = 1;
        draft.liveUnpaidLogFailure = true;
        break;

      case FETCH_LIVE_COMP_ORDER_LOG_REQUEST:
        draft.liveCompOrderLogLoading = true;
        draft.liveCompOrderLog = [];
        draft.liveCompOrderLogTotalElements = 0;
        draft.liveCompOrderLogTotalPages = 1;
        draft.liveCompOrderLogFailure = false;
        break;
      case FETCH_LIVE_COMP_ORDER_LOG_SUCCESS:
        draft.liveCompOrderLogLoading = false;
        draft.liveCompOrderLog = action.payload.orders ?? [];
        draft.liveCompOrderLogTotalElements = Number(action.payload.totalElements) || 0;
        draft.liveCompOrderLogTotalPages = Number(action.payload.totalPages) || 1;
        draft.liveCompOrderLogFailure = false;
        break;
      case FETCH_LIVE_COMP_ORDER_LOG_FAILURE:
        draft.liveCompOrderLogLoading = false;
        draft.liveCompOrderLog = [];
        draft.liveCompOrderLogTotalElements = 0;
        draft.liveCompOrderLogTotalPages = 1;
        draft.liveCompOrderLogFailure = true;
        break;

      case FETCH_LIVE_COMP_REASONS_REQUEST:
        draft.liveCompReasonsLoading = true;
        draft.liveCompReasons = [];
        draft.liveCompReasonsFailure = false;
        break;
      case FETCH_LIVE_COMP_REASONS_SUCCESS:
        draft.liveCompReasonsLoading = false;
        draft.liveCompReasons = action.payload.reasons ?? [];
        draft.liveCompReasonsFailure = false;
        break;
      case FETCH_LIVE_COMP_REASONS_FAILURE:
        draft.liveCompReasonsLoading = false;
        draft.liveCompReasons = [];
        draft.liveCompReasonsFailure = true;
        break;

      case FETCH_LIVE_COMP_BY_STAFF_REQUEST:
        draft.liveCompByStaffLoading = true;
        draft.liveCompByStaff = [];
        draft.liveCompByStaffFailure = false;
        break;
      case FETCH_LIVE_COMP_BY_STAFF_SUCCESS:
        draft.liveCompByStaffLoading = false;
        draft.liveCompByStaff = action.payload ?? [];
        draft.liveCompByStaffFailure = false;
        break;
      case FETCH_LIVE_COMP_BY_STAFF_FAILURE:
        draft.liveCompByStaffLoading = false;
        draft.liveCompByStaff = [];
        draft.liveCompByStaffFailure = true;
        break;

      case FETCH_LIVE_CATEGORY_SALES_REQUEST:
        draft.liveCategorySalesLoading = true;
        draft.liveCategorySalesSuccess = [];
        draft.liveCategorySalesFailure = false;
        break;
      case FETCH_LIVE_CATEGORY_SALES_SUCCESS:
        draft.liveCategorySalesLoading = false;
        draft.liveCategorySalesSuccess = action.payload?.categories ?? [];
        draft.liveCategorySalesPage = action.payload?.page ?? 1;
        draft.liveCategorySalesSize = action.payload?.size ?? draft.liveCategorySalesSize;
        draft.liveCategorySalesTotalElements = action.payload?.totalElements ?? 0;
        draft.liveCategorySalesTotalPages = action.payload?.totalPages ?? 1;
        draft.liveCategorySalesFailure = false;
        break;
      case FETCH_LIVE_CATEGORY_SALES_FAILURE:
        draft.liveCategorySalesLoading = false;
        draft.liveCategorySalesSuccess = [];
        draft.liveCategorySalesTotalElements = 0;
        draft.liveCategorySalesTotalPages = 1;
        draft.liveCategorySalesFailure = true;
        break;

      case FETCH_LIVE_STAFF_REFUNDS_REQUEST:
        draft.liveStaffRefundsLoading = true;
        draft.liveStaffRefundsSuccess = [];
        draft.liveStaffRefundsFailure = false;
        break;
      case FETCH_LIVE_STAFF_REFUNDS_SUCCESS:
        draft.liveStaffRefundsLoading = false;
        draft.liveStaffRefundsSuccess = action.payload ?? [];
        draft.liveStaffRefundsFailure = false;
        break;
      case FETCH_LIVE_STAFF_REFUNDS_FAILURE:
        draft.liveStaffRefundsLoading = false;
        draft.liveStaffRefundsSuccess = [];
        draft.liveStaffRefundsFailure = true;
        break;

      case FETCH_SNAPSHOT_COMPARISON_REQUEST:
        draft.snapshotComparisonLoading = true;
        draft.snapshotComparisonSuccess = null;
        draft.snapshotComparisonFailure = false;
        break;
      case FETCH_SNAPSHOT_COMPARISON_SUCCESS:
        draft.snapshotComparisonLoading = false;
        draft.snapshotComparisonSuccess = action.payload;
        draft.snapshotComparisonFailure = false;
        break;
      case FETCH_SNAPSHOT_COMPARISON_FAILURE:
        draft.snapshotComparisonLoading = false;
        draft.snapshotComparisonSuccess = null;
        draft.snapshotComparisonFailure = true;
        break;

      case FETCH_CHANNEL_NAMES_REQUEST:
        draft.channelNamesLoading = true;
        draft.channelNamesError = false;
        break;
      case FETCH_CHANNEL_NAMES_SUCCESS:
        draft.channelNamesLoading = false;
        draft.channelNamesError = false;
        draft.channelNames = (action.payload ?? []).filter((name: string) => name !== '');
        break;
      case FETCH_CHANNEL_NAMES_FAILURE:
        draft.channelNamesLoading = false;
        draft.channelNamesError = true;
        break;

      case FETCH_LIVE_OUTSTANDING_VALUE_REQUEST:
        draft.liveOutstandingValueLoading = true;
        draft.liveOutstandingValue = null;
        draft.liveOutstandingValueFailure = false;
        break;
      case FETCH_LIVE_OUTSTANDING_VALUE_SUCCESS:
        draft.liveOutstandingValueLoading = false;
        draft.liveOutstandingValue = action.payload;
        draft.liveOutstandingValueFailure = false;
        break;
      case FETCH_LIVE_OUTSTANDING_VALUE_FAILURE:
        draft.liveOutstandingValueLoading = false;
        draft.liveOutstandingValue = null;
        draft.liveOutstandingValueFailure = true;
        break;

      case FETCH_LABOUR_EMPLOYEE_SALES_REQUEST:
        draft.labourEmployeeSalesLoading = true;
        draft.labourEmployeeSalesSummary = null;
        draft.labourEmployeeSalesFailure = false;
        break;
      case FETCH_LABOUR_EMPLOYEE_SALES_SUCCESS:
        draft.labourEmployeeSalesLoading = false;
        draft.labourEmployeeSalesItems = action.payload.content ?? [];
        draft.labourEmployeeSalesSummary = action.payload.summary ?? null;
        draft.labourEmployeeSalesFailure = false;
        break;
      case FETCH_LABOUR_EMPLOYEE_SALES_FAILURE:
        draft.labourEmployeeSalesLoading = false;
        draft.labourEmployeeSalesSummary = null;
        draft.labourEmployeeSalesFailure = true;
        break;

      case FETCH_LABOUR_TIPS_REQUEST:
        draft.labourTipsLoading = true;
        draft.labourTipsSummary = null;
        draft.labourTipsFailure = false;
        break;
      case FETCH_LABOUR_TIPS_SUCCESS:
        draft.labourTipsLoading = false;
        draft.labourTipsItems = action.payload.content ?? [];
        draft.labourTipsSummary = action.payload.summary ?? null;
        draft.labourTipsFailure = false;
        break;
      case FETCH_LABOUR_TIPS_FAILURE:
        draft.labourTipsLoading = false;
        draft.labourTipsSummary = null;
        draft.labourTipsFailure = true;
        break;

      case FETCH_LABOUR_VOIDS_REQUEST:
        draft.labourVoidsLoading = true;
        draft.labourVoidsData = null;
        draft.labourVoidsFailure = false;
        break;
      case FETCH_LABOUR_VOIDS_SUCCESS:
        draft.labourVoidsLoading = false;
        draft.labourVoidsData = action.payload;
        draft.labourVoidsFailure = false;
        break;
      case FETCH_LABOUR_VOIDS_FAILURE:
        draft.labourVoidsLoading = false;
        draft.labourVoidsData = null;
        draft.labourVoidsFailure = true;
        break;

      case FETCH_LABOUR_WORKING_HOURS_REQUEST:
        draft.labourWorkingHoursLoading = true;
        draft.labourWorkingHoursSummary = null;
        draft.labourWorkingHoursFailure = false;
        break;
      case FETCH_LABOUR_WORKING_HOURS_SUCCESS:
        draft.labourWorkingHoursLoading = false;
        draft.labourWorkingHoursItems = action.payload.content ?? [];
        draft.labourWorkingHoursTotalElements = Number(action.payload.totalElements) || 0;
        draft.labourWorkingHoursSummary = action.payload.summary ?? null;
        draft.labourWorkingHoursFailure = false;
        break;
      case FETCH_LABOUR_WORKING_HOURS_FAILURE:
        draft.labourWorkingHoursLoading = false;
        draft.labourWorkingHoursSummary = null;
        draft.labourWorkingHoursFailure = true;
        break;

      case FETCH_LABOUR_STAFF_PERFORMANCE_REQUEST:
        draft.labourStaffPerformanceLoading = true;
        draft.labourStaffPerformanceItems = [];
        draft.labourStaffPerformanceFailure = false;
        break;
      case FETCH_LABOUR_STAFF_PERFORMANCE_SUCCESS:
        draft.labourStaffPerformanceLoading = false;
        draft.labourStaffPerformanceItems = action.payload.content ?? [];
        draft.labourStaffPerformanceTotalElements = Number(action.payload.totalElements) || 0;
        draft.labourStaffPerformanceTotalPages = Number(action.payload.totalPages) || 1;
        draft.labourStaffPerformanceSummary = action.payload.summary ?? null;
        draft.labourStaffPerformanceFailure = false;
        break;
      case FETCH_LABOUR_STAFF_PERFORMANCE_FAILURE:
        draft.labourStaffPerformanceLoading = false;
        draft.labourStaffPerformanceItems = [];
        draft.labourStaffPerformanceTotalElements = 0;
        draft.labourStaffPerformanceTotalPages = 1;
        draft.labourStaffPerformanceFailure = true;
        break;

      case FETCH_LABOUR_WORKING_HOURS_LOG_REQUEST:
        draft.labourWorkingHoursLogLoading = true;
        draft.labourWorkingHoursLogItems = [];
        draft.labourWorkingHoursLogFailure = false;
        break;
      case FETCH_LABOUR_WORKING_HOURS_LOG_SUCCESS:
        draft.labourWorkingHoursLogLoading = false;
        draft.labourWorkingHoursLogItems = action.payload.content ?? [];
        draft.labourWorkingHoursLogTotalElements = Number(action.payload.totalElements) || 0;
        draft.labourWorkingHoursLogTotalPages = Number(action.payload.totalPages) || 1;
        draft.labourWorkingHoursLogFailure = false;
        break;
      case FETCH_LABOUR_WORKING_HOURS_LOG_FAILURE:
        draft.labourWorkingHoursLogLoading = false;
        draft.labourWorkingHoursLogItems = [];
        draft.labourWorkingHoursLogTotalElements = 0;
        draft.labourWorkingHoursLogTotalPages = 1;
        draft.labourWorkingHoursLogFailure = true;
        break;

      case FETCH_LABOUR_KPI_COMPARISON_REQUEST:
        draft.labourKpiComparisonLoading = true;
        draft.labourKpiComparison = null;
        draft.labourKpiComparisonFailure = false;
        break;
      case FETCH_LABOUR_KPI_COMPARISON_SUCCESS:
        draft.labourKpiComparisonLoading = false;
        draft.labourKpiComparison = action.payload;
        draft.labourKpiComparisonFailure = false;
        break;
      case FETCH_LABOUR_KPI_COMPARISON_FAILURE:
        draft.labourKpiComparisonLoading = false;
        draft.labourKpiComparison = null;
        draft.labourKpiComparisonFailure = true;
        break;

      case FETCH_LABOUR_EMPLOYEES_REQUEST:
        draft.labourEmployeesLoading = true;
        draft.labourEmployees = [];
        draft.labourEmployeesFailure = false;
        break;
      case FETCH_LABOUR_EMPLOYEES_SUCCESS:
        draft.labourEmployeesLoading = false;
        draft.labourEmployees = action.payload.employees ?? [];
        draft.labourEmployeesFailure = false;
        break;
      case FETCH_LABOUR_EMPLOYEES_FAILURE:
        draft.labourEmployeesLoading = false;
        draft.labourEmployees = [];
        draft.labourEmployeesFailure = true;
        break;

      case FETCH_SALES_BY_CHANNEL_BREAKDOWN_REQUEST:
        draft.salesByChannelBreakdownLoading = true;
        draft.salesByChannelBreakdown = null;
        draft.salesByChannelBreakdownFailure = false;
        break;
      case FETCH_SALES_BY_CHANNEL_BREAKDOWN_SUCCESS:
        draft.salesByChannelBreakdownLoading = false;
        draft.salesByChannelBreakdown = action.payload ?? null;
        draft.salesByChannelBreakdownFailure = false;
        break;
      case FETCH_SALES_BY_CHANNEL_BREAKDOWN_FAILURE:
        draft.salesByChannelBreakdownLoading = false;
        draft.salesByChannelBreakdown = null;
        draft.salesByChannelBreakdownFailure = true;
        break;

      case FETCH_LIVE_BY_SOURCE_REQUEST:
        draft.liveBySourceLoading = true;
        draft.liveBySourceSuccess = [];
        draft.liveBySourceFailure = false;
        break;
      case FETCH_LIVE_BY_SOURCE_SUCCESS:
        draft.liveBySourceLoading = false;
        draft.liveBySourceSuccess = action.payload;
        draft.liveBySourceFailure = false;
        break;
      case FETCH_LIVE_BY_SOURCE_FAILURE:
        draft.liveBySourceLoading = false;
        draft.liveBySourceSuccess = [];
        draft.liveBySourceFailure = true;
        break;

      default:
        return state;
    }
  });
}
